import { playReferenceAudio } from "./reference-audio";
import type { ReferenceLookupPorts } from "./reference-lookup";

// No dictionary endpoint or pronunciation adapter exists yet, so both loaders
// resolve empty: the drawer reads that as an ordinary absence, which is the
// truth, where a rejection would offer a retry that cannot succeed.
export const readerReferencePorts: ReferenceLookupPorts = {
  dictionary: () => Promise.resolve([]),
  pronunciations: () => Promise.resolve([]),
  play: playReferenceAudio,
};
